import { RenderUnsettledUI } from 'shared/components';
import { useParams } from 'react-router-dom';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useSiteDetection } from 'shared/hooks';
import { TodoSection } from './todo-list';
import { useGetUnfulfilledShifts } from '../../../../../../api/hooks/dashboard/todo/use-get-unfulfilled-shifts';
import { useGetOpenCheckouts } from '../../../../../../api/hooks/dashboard/todo/use-get-open-checkouts';
import { useGetNotPlannedWork } from '../../../../../../api/hooks/dashboard/todo/use-get-not-planned-work';

export const TodoSectionDataProvider = () => {
  const { companyId } = useParams();
  const { site } = useSiteDetection();
  const generatePath = useCompanyRelativePath();

  const unfullfilledShiftsQuery = useGetUnfulfilledShifts(site);
  const openCheckoutsQuery = useGetOpenCheckouts(site);
  const notPlannedWorkQuery = useGetNotPlannedWork(site);

  if (unfullfilledShiftsQuery.isError) {
    return <RenderUnsettledUI data={unfullfilledShiftsQuery} />;
  }

  if (openCheckoutsQuery.isError) {
    return <RenderUnsettledUI data={openCheckoutsQuery} />;
  }

  if (notPlannedWorkQuery.isError) {
    return <RenderUnsettledUI data={notPlannedWorkQuery} />;
  }

  return (
    <TodoSection
      data={{
        ...unfullfilledShiftsQuery.data,
        ...openCheckoutsQuery.data,
        ...notPlannedWorkQuery.data,
      }}
      generatePath={generatePath}
      companyId={companyId}
    />
  );
};
